import React from "react";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import classNames from "classnames";
import { withStyles } from "@material-ui/core/styles";
import Drawer from "@material-ui/core/Drawer";
import IconButton from "@material-ui/core/IconButton";
import Divider from "@material-ui/core/Divider";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import InsertDriveFileIcon from "@material-ui/icons/InsertDriveFile";
import SettingsIcon from "@material-ui/icons/Settings";
import {
  ChevronLeft,
  ChevronRight,
  PermMedia,
  LocalOffer,
  ShoppingCart,
  FormatListBulleted,
  Group,
  ExitToApp,
  CalendarTodaySharp,
  Store,
  Label,
  LocalShipping,
  LocationOn,
  Palette,
} from "@material-ui/icons";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import ShoppingBasketIcon from "@material-ui/icons/ShoppingBasket";
import PaymentIcon from "@material-ui/icons/Payment";
const drawerWidth = 300;
const rolesArticulos = [1, 2];
const rolesPedidos = [1, 4];
const rolesRubros = [1, 2];
const rolesUsuarios = [1];

const styles = (theme) => ({
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: "nowrap",
    [theme.breakpoints.down("sm")]: {
      width: "75%",
    },
  },
  drawerOpen: {
    width: drawerWidth,
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    [theme.breakpoints.down("sm")]: {
      width: "300px",
    },
  },
  drawerClose: {
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: "hidden",
    width: theme.spacing.unit * 7 + 1,
    [theme.breakpoints.up("sm")]: {
      width: theme.spacing.unit * 9 + 1,
    },
    [theme.breakpoints.down("sm")]: {
      width: theme.spacing.unit * 6,
    },
  },
  toolbar: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "0 8px",
    ...theme.mixins.toolbar,
    [theme.breakpoints.down("sm")]: {
      justifyContent: "flex-start",
    },
  },
  logoContainer: {
    display: "flex",
    justifyContent: "center",
    width: "100%",
    [theme.breakpoints.down("sm")]: {
      justifyContent: "flex-start",
      paddingLeft: theme.spacing.unit * 2,
    },
  },
  listItem: {
    [theme.breakpoints.down("sm")]: {
      justifyContent: "flex-start",
      paddingLeft: theme.spacing.unit,
    },
  },
  listItemIcon: {
    [theme.breakpoints.down("sm")]: {
      marginRight: theme.spacing.unit,
    },
  },
  listItemText: {
    [theme.breakpoints.down("sm")]: {
      fontSize: "0.875rem",
    },
  },
});

class MyDrawer extends React.Component {
  render() {
    const { classes, theme } = this.props;

    return (
      <Drawer
        variant={this.props.isPermanent ? "permanent" : "drawerNoPermanent"}
        className={classNames(classes.drawer, {
          [classes.drawerOpen]: this.props.drawerOpen,
          [classes.drawerClose]: !this.props.drawerOpen,
        })}
        classes={{
          paper: classNames({
            [classes.drawerOpen]: this.props.drawerOpen,
            [classes.drawerClose]: !this.props.drawerOpen,
          }),
        }}
        open={this.props.drawerOpen}
      >
        <div className={classNames(classes.toolbar, "drawerToolbarHeader")}>
          <div className={classNames(classes.logoContainer, "logoContainer center")}>
            <Link to="/">
              <img alt="grey logo" src={this.props.instalacion.ecommerceGreyscale} />
            </Link>
          </div>
          <IconButton onClick={this.props.handleDrawerClose}>
            {theme.direction === "rtl" ? <ChevronRight /> : <ChevronLeft />}
          </IconButton>
        </div>
        <Divider />
        <List className="menuItem">
          {this.props.usuario &&
            this.props.instalacion !== undefined &&
            rolesArticulos.find((x) => x === this.props.usuario.idRol) > 0 && (
              <Link
                to={"/Catalogo/" + this.props.instalacion.id}
                onClick={this.props.handleDrawerClose}
              >
                <ListItem button key="catalogo" className={classes.listItem}>
                  <ListItemIcon className={classes.listItemIcon}>
                    <PermMedia />
                  </ListItemIcon>
                  <ListItemText primary="Catálogo" className={classes.listItemText} />
                </ListItem>
              </Link>
            )}
          <Link to={"/Articulo"}>
            <ListItem
              button
              key="articulos"
              onClick={this.props.handleDrawerClose}
              className={classes.listItem}
            >
              <ListItemIcon className={classes.listItemIcon}>
                <LocalOffer />
              </ListItemIcon>
              <ListItemText primary="Artículos" className={classes.listItemText} />
            </ListItem>
          </Link>
          {this.props.usuario && rolesPedidos.find((x) => x === this.props.usuario.idRol) > 0 && (
            <Link to={"/Pedidos"}>
              <ListItem
                button
                key="pedidos"
                onClick={this.props.handleDrawerClose}
                className={classes.listItem}
              >
                <ListItemIcon className={classes.listItemIcon}>
                  <ShoppingCart />
                </ListItemIcon>
                <ListItemText primary="Pedidos" className={classes.listItemText} />
              </ListItem>
            </Link>
          )}
          {this.props.usuario && rolesPedidos.find((x) => x === this.props.usuario.idRol) > 0 && (
            <Link to={"/Calendario"}>
              <ListItem
                button
                key="calendario_pedidos"
                onClick={this.props.handleDrawerClose}
                className={classes.listItem}
              >
                <ListItemIcon className={classes.listItemIcon}>
                  <CalendarTodaySharp />
                </ListItemIcon>
                <ListItemText primary="Calendario de pedidos" className={classes.listItemText} />
              </ListItem>
            </Link>
          )}
          {this.props.usuario && rolesPedidos.find((x) => x === this.props.usuario.idRol) > 0 && (
            <Link to={"/Oferta"}>
              <ListItem
                button
                key="oferta"
                onClick={this.props.handleDrawerClose}
                className={classes.listItem}
              >
                <ListItemIcon className={classes.listItemIcon}>
                  <AttachMoneyIcon />
                </ListItemIcon>
                <ListItemText primary="Oferta" className={classes.listItemText} />
              </ListItem>
            </Link>
          )}
          {this.props.usuario && rolesRubros.find((x) => x === this.props.usuario.idRol) > 0 && (
            <Link to={"/Rubros"} onClick={this.props.handleDrawerClose}>
              <ListItem button key="rubros" className={classes.listItem}>
                <ListItemIcon className={classes.listItemIcon}>
                  <FormatListBulleted />
                </ListItemIcon>
                <ListItemText primary="Rubros" className={classes.listItemText} />
              </ListItem>
            </Link>
          )}
          {this.props.usuario && rolesRubros.find((x) => x === this.props.usuario.idRol) > 0 && (
            <Link to={"/Marcas"} onClick={this.props.handleDrawerClose}>
              <ListItem button key="marcas" className={classes.listItem}>
                <ListItemIcon className={classes.listItemIcon}>
                  <Label />
                </ListItemIcon>
                <ListItemText primary="Marcas" className={classes.listItemText} />
              </ListItem>
            </Link>
          )}
          {this.props.usuario && rolesRubros.find((x) => x === this.props.usuario.idRol) > 0 && (
            <Link to={"/Proveedores"} onClick={this.props.handleDrawerClose}>
              <ListItem button key="proveedores" className={classes.listItem}>
                <ListItemIcon className={classes.listItemIcon}>
                  <LocalShipping />
                </ListItemIcon>
                <ListItemText primary="Proveedores" className={classes.listItemText} />
              </ListItem>
            </Link>
          )}
          {this.props.usuario && rolesRubros.find((x) => x === this.props.usuario.idRol) > 0 && (
            <Link to={"/LocalidadesEntrega"} onClick={this.props.handleDrawerClose}>
              <ListItem button key="localidades-entrega" className={classes.listItem}>
                <ListItemIcon className={classes.listItemIcon}>
                  <LocationOn />
                </ListItemIcon>
                <ListItemText
                  primary="Localidades de Entrega"
                  className={classes.listItemText}
                />
              </ListItem>
            </Link>
          )}
          {this.props.usuario && rolesRubros.find((x) => x === this.props.usuario.idRol) > 0 && (
            <Link to={"/Picking"} onClick={this.props.handleDrawerClose}>
              <ListItem button key="picking" className={classes.listItem}>
                <ListItemIcon className={classes.listItemIcon}>
                  <ShoppingBasketIcon />
                </ListItemIcon>
                <ListItemText primary="Picking" className={classes.listItemText} />
              </ListItem>
            </Link>
          )}
          {this.props.usuario && rolesRubros.find((x) => x === this.props.usuario.idRol) > 0 && (
            <Link to={"/Contenido"} onClick={this.props.handleDrawerClose}>
              <ListItem button key="contenido" className={classes.listItem}>
                <ListItemIcon className={classes.listItemIcon}>
                  <InsertDriveFileIcon />
                </ListItemIcon>
                <ListItemText primary="Contenido" className={classes.listItemText} />
              </ListItem>
            </Link>
          )}
          {this.props.usuario && rolesRubros.find((x) => x === this.props.usuario.idRol) > 0 && (
            <Link to={"/Configuracion"} onClick={this.props.handleDrawerClose}>
              <ListItem button key="Configuracion" className={classes.listItem}>
                <ListItemIcon className={classes.listItemIcon}>
                  <SettingsIcon />
                </ListItemIcon>
                <ListItemText primary="Configuración" className={classes.listItemText} />
              </ListItem>
            </Link>
          )}
          {this.props.usuario && rolesRubros.find((x) => x === this.props.usuario.idRol) > 0 && (
            <Link to={"/Diseno"} onClick={this.props.handleDrawerClose}>
              <ListItem button key="diseno" className={classes.listItem}>
                <ListItemIcon className={classes.listItemIcon}>
                  <Palette />
                </ListItemIcon>
                <ListItemText primary="Diseño" className={classes.listItemText} />
              </ListItem>
            </Link>
          )}
          {this.props.usuario && rolesUsuarios.find((x) => x === this.props.usuario.idRol) > 0 && (
            <Link to={"/Usuarios"}>
              <ListItem
                button
                key="usuarios"
                onClick={this.props.handleDrawerClose}
                className={classes.listItem}
              >
                <ListItemIcon className={classes.listItemIcon}>
                  <Group />
                </ListItemIcon>
                <ListItemText primary="Usuarios" className={classes.listItemText} />
              </ListItem>
            </Link>
          )}
          {this.props.instalacion !== undefined &&
            this.props.instalacion.habilitarNivelListaPrecio &&
            this.props.usuario &&
            rolesRubros.find((x) => x === this.props.usuario.idRol) > 0 && (
              <Link to={"/Niveles"} onClick={this.props.handleDrawerClose}>
                <ListItem button key="niveles" className={classes.listItem}>
                  <ListItemIcon className={classes.listItemIcon}>
                    <Label />
                  </ListItemIcon>
                  <ListItemText primary="Niveles" className={classes.listItemText} />
                </ListItem>
              </Link>
            )}
          {this.props.usuario && rolesUsuarios.find((x) => x === this.props.usuario.idRol) > 0 && (
            <Link to={"/Sucursales"}>
              <ListItem
                button
                key="sucursales"
                onClick={this.props.handleDrawerClose}
                className={classes.listItem}
              >
                <ListItemIcon className={classes.listItemIcon}>
                  <Store />
                </ListItemIcon>
                <ListItemText primary="Sucursales" className={classes.listItemText} />
              </ListItem>
            </Link>
          )}
          {this.props.usuario && rolesUsuarios.find((x) => x === this.props.usuario.idRol) > 0 && (
            <Link to={"/PagosYDevoluciones"}>
              <ListItem
                button
                key="pagos"
                onClick={this.props.handleDrawerClose}
                className={classes.listItem}
              >
                <ListItemIcon className={classes.listItemIcon}>
                  <PaymentIcon />
                </ListItemIcon>
                <ListItemText primary="Pagos y devoluciones" className={classes.listItemText} />
              </ListItem>
            </Link>
          )}
          <ListItem
            button
            key="cerrarSesion"
            onClick={() => this.props.handleCerrarSession()}
            id="itemCerrarSesion"
            className={classes.listItem}
          >
            <ListItemIcon id="iconoCerrarSesion" className={classes.listItemIcon}>
              <ExitToApp />
            </ListItemIcon>
            <ListItemText
              primary="Cerrar sesión"
              id="textoCerrarSesion"
              className={classes.listItemText}
            />
          </ListItem>
        </List>
      </Drawer>
    );
  }
}

MyDrawer.propTypes = {
  drawerOpen: PropTypes.bool.isRequired,

  handleDrawerClose: PropTypes.func.isRequired,
  handleCerrarSession: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
  usuario: PropTypes.object.isRequired,
  isPermanent: PropTypes.bool.isRequired,
};

export default withStyles(styles, { withTheme: true })(MyDrawer);
